import { api } from "./service.js";
import brandinfo from "../data/brand/index.js";
const brand = {
  //获取品牌分类
  getGoodsClass(brandid) {
    return api.post("pc/brand/page", { id: brandid });
  },
  getGoodsBrandClass(brandid) {
    return api.post("pc/brand/class", { id: brandid });
  },
  //
  getBrandInfo(brandid) {
    var info = {};
    brandid = brandid + "";
    switch (brandid) {
      case "1":
        info = brandinfo.brand1;
        break;
      case "2":
        info = brandinfo.brand2;
        break;
      case "3":
        info = brandinfo.brand3;
        break;
      case "4":
        info = brandinfo.brand4;
        break;
      case "5":
        info = brandinfo.brand5;
        break;
      case "9":
        info = brandinfo.brand9;
        break;
      case "10":
        info = brandinfo.brand10;
        break;
      case "11":
        info = brandinfo.brand11;
        break;
      default:
        info = brandinfo.brand5;
    }
    return info;
  }
};
export default brand;



// WEBPACK FOOTER //
// ./src/service/brand.js